import logo from './logo.webp';
import './App.css';
import HorizontalCalendar from './components/Calendar'
import ProjectComponent from './components/Projects';
import DevChannelComponent from './components/DevChannels';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import MonthPicker from './components/MonthPicker';
import dayjs from 'dayjs';
import Login from './components/Login';
import GoogleLogin from './components/GoogleLogin';
import devPulseImage from './devpulse.webp';
function App() {

  axios.interceptors.response.use(
    (response) => {
      // Handle successful responses
      return response;
    },
    (error) => {
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        // Do something when a 401 happens
        setUser(null);
  
        // Optionally, you can redirect to the login page or refresh the token
        // window.location.href = '/login'; 
        // refreshToken(); 
      }
  
      // Reject the promise to propagate the error
      return Promise.reject(error);
    }
  );
  
  const [devChannels, setDevChannels] = useState([]);
  const [projects, setProjects] = useState([]);
  const [startDate, setStartDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));
  const [user, setUser] = useState(null);
  
  // Fetch all devChannels on component mount
  useEffect(() => {
    fetchDevChannels();
    fetchProjects();
    if(localStorage.getItem('user')) {
      setUser(JSON.parse(localStorage.getItem('user')));
    }
  }, []);
  
  const fetchDevChannels = async () => {
    try {
      const response = await axios.get('/api/devChannels');
      setDevChannels(response.data);
    } catch (error) {
      console.error('Error fetching devChannels:', error);
    }
  };
  
  const fetchProjects = async () => {
    try {
      const response = await axios.get('/api/projects');
      let projectArray = [];
      response.data.forEach(project => { 
        projectArray.push({
          ...project,
          startDate: project.projectStartDate.substring(0, 10),
          endDate: project.projectEndDate.substring(0, 10)
        })
      }   
      )
      setProjects(projectArray)

    } catch (error) {
      console.error('Error fetching projects:', error);
    }
  };

  const handleMonthChange = (newStartDate, newEndDate) => {
      setStartDate(newStartDate);
      setEndDate(newEndDate);
  };
  
  const handleLoginSuccess = (userData) => {
    axios.post('/api/auth/google', { "token": userData }).then((result) => {
      console.log(result)
      setUser(result.data);
      localStorage.setItem('user', JSON.stringify(result.data));
      fetchProjects();
      fetchDevChannels();
    }).catch((error) => {
        alert('Error logging in: Please make sure to use an MXS Email');
    })
  };
  
  const handleLoginFailure = (error) => {
    console.error('Login failed:', error);
    alert('Login failed. Please try again.');
  };

  if (!user) {
    return (
      <div style={{width: "100vw", height: "100vh", justifyContent: "center", display: "flex", paddingTop: "10%", background: "rgb(34 39 47)", color: "white"}}>
        <div style={{display: "flex", flexDirection: "column", textAlign: "center"}}>
          <h1>Welcome to MXS DevPulse</h1> 
          <img src={devPulseImage} style={{width: "400px", height: "400px", margin: "20px"}} />
          <div style={{justifyContent: "center"}}>
            <p>Login with your company Email</p>
            <GoogleLogin
              onLoginSuccess={handleLoginSuccess}
              onLoginFailure={handleLoginFailure}
            />
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="App">
      <div style={{position: "fixed", top: "25px", right: "25px"}}>
        <MonthPicker onMonthChange={handleMonthChange} />
      </div>
      {devChannels
        .filter((channel) => {
            // If channel has no start or end date, include it
            if (!channel.channelStartDate && !channel.channelEndDate) {
              return true;
            }
        
            // Parse channel dates for comparison
            const channelStartDate = channel.channelStartDate ? dayjs(channel.channelStartDate) : null;
            const channelEndDate = channel.channelEndDate ? dayjs(channel.channelEndDate) : null;
        
            // Check overlap with the given startDate and endDate
            const rangeStartDate = dayjs(startDate);
            const rangeEndDate = dayjs(endDate);
        
            // Logic for overlapping ranges
            return (
              (!channelStartDate || channelStartDate.isBefore(rangeEndDate, 'day')) &&
              (!channelEndDate || channelEndDate.isAfter(rangeStartDate, 'day'))
            );
          }).map((channel) => {
        console.log(channel)
        return (
          <div>
            <h1 style={{textAlign: "left", marginLeft: "15px"}}>{channel.name}</h1>
            <HorizontalCalendar
            startDate={startDate}
            endDate={endDate}
            projects={projects.filter(project => project.devChannelId._id === channel._id)}
            backgroundColor={channel.backgroundColor}
            textColor={channel.textColor}
            scrollView={true}
          />
        </div>
        
      )})}
      {localStorage.getItem("editor") === 'true' &&
        <div style={{ display: "flex", justifyContent: "center" }}>
          <ProjectComponent callback={fetchProjects} />
          <DevChannelComponent />
        </div>
      }
    </div>
  );
}

export default App;
